import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-325px w-md-375px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_5 = { class: "px-7 py-5" }
const _hoisted_6 = { class: "row mb-8" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "col-6 mt-3" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "col-6 mt-3" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "col-6 mt-3"
}
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = {
  key: 1,
  class: "col-6 mt-3"
}
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "col-6 mt-3" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = {
  key: 2,
  class: "col-6 mt-3"
}
const _hoisted_22 = {
  key: 3,
  class: "col-6 mt-3"
}
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = {
  key: 4,
  class: "col-6 mt-3"
}
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = { class: "col-6 mt-3" }
const _hoisted_27 = ["label"]
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 5,
  class: "col-6 mt-3"
}
const _hoisted_30 = {
  key: 6,
  class: "col-6 mt-3"
}
const _hoisted_31 = ["label"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "supplier" }, "supplier", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "merchant" }, "merchant", -1)
const _hoisted_34 = { class: "col-6 mt-3" }
const _hoisted_35 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('filterOptions')), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            name: "phone",
            class: "form-control form-control-sm form-control-solid",
            placeholder: _ctx.translate('phoneNumber'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.phone) = $event))
          }, null, 8, _hoisted_8), [
            [_vModelText, _ctx.selectedItems.phone]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-sm form-control-solid",
            placeholder: _ctx.translate('Customer Name'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.name) = $event))
          }, null, 8, _hoisted_10), [
            [_vModelText, _ctx.selectedItems.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-sm form-control-solid",
            placeholder: _ctx.translate('Driver Name'),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.driverName) = $event))
          }, null, 8, _hoisted_12), [
            [_vModelText, _ctx.selectedItems.driverName]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-sm form-control-solid",
            placeholder: _ctx.translate('Package ID'),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItems.trackNumber) = $event))
          }, null, 8, _hoisted_14), [
            [_vModelText, _ctx.selectedItems.trackNumber]
          ])
        ]),
        (_ctx.pathRoute !== '/manage/packages/merchant-packages-listing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control form-control-sm form-control-solid",
                placeholder: _ctx.translate('start Date'),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems.startDate) = $event))
              }, null, 8, _hoisted_16), [
                [_vModelText, _ctx.selectedItems.startDate]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.pathRoute !== '/manage/packages/merchant-packages-listing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control form-control-sm form-control-solid",
                placeholder: _ctx.translate('End Date'),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItems.endDate) = $event))
              }, null, 8, _hoisted_18), [
                [_vModelText, _ctx.selectedItems.endDate]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-sm form-control-solid",
            placeholder: _ctx.translate('docId'),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedItems.docId) = $event))
          }, null, 8, _hoisted_20), [
            [_vModelText, _ctx.selectedItems.docId]
          ])
        ]),
        (
            _ctx.pathRoute !== '/manage/packages/merchant-packages-listing' &&
            _ctx.pathRoute !== '/manage/packages/supplier-packages-listing'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_Multiselect, {
                class: "custom-multiselect",
                modelValue: _ctx.selectedHubs,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedHubs) = $event)),
                mode: "tags",
                "close-on-select": false,
                requierd: false,
                label: "title",
                trackBy: "title",
                searchable: true,
                canDeselect: false,
                options: _ctx.hubsTitle(),
                placeholder: _ctx.translate('Select Hubs'),
                valueProp: "id",
                noResultsText: _ctx.translate('noResultsFound')
              }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.pathRoute !== '/manage/packages/merchant-packages-listing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-sm form-control-solid",
                placeholder: _ctx.translate('Shipment ID'),
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedItems.shipmentTrackNumber) = $event))
              }, null, 8, _hoisted_23), [
                [_vModelText, _ctx.selectedItems.shipmentTrackNumber]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.pathRoute !== '/manage/packages/merchant-packages-listing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-sm form-control-solid",
                placeholder: _ctx.translate('Office Name'),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedItems.officeName) = $event))
              }, null, 8, _hoisted_25), [
                [_vModelText, _ctx.selectedItems.officeName]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedItems.statusId) = $event)),
            class: "form-select form-select-sm form-select-solid"
          }, [
            _createElementVNode("option", {
              label: _ctx.translate('Package Status'),
              selected: "",
              disabled: "",
              value: ""
            }, null, 8, _hoisted_27),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentStatuses, (shipmentStatus) => {
              return (_openBlock(), _createElementBlock("option", {
                key: shipmentStatus.id,
                value: shipmentStatus.id
              }, _toDisplayString(shipmentStatus.internal[1].title), 9, _hoisted_28))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedItems.statusId]
          ])
        ]),
        (_ctx.pathRoute !== '/manage/packages/merchant-packages-listing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.selectedGovernorate,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedGovernorate) = $event)),
                class: "custom-multiselect",
                "close-on-select": false,
                requierd: false,
                label: "title",
                trackBy: "title",
                options: _ctx.governorateTitle(),
                searchable: true,
                canDeselect: false,
                placeholder: _ctx.translate('Select Governorate'),
                valueProp: "id",
                noResultsText: _ctx.translate('noResultsFound')
              }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.pathRoute === '/manage/packages/hub-packages-listing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedItems.originType) = $event)),
                class: "form-select form-select-sm form-select-solid"
              }, [
                _createElementVNode("option", {
                  label: _ctx.translate('selectType'),
                  selected: "",
                  disabled: "",
                  value: ""
                }, null, 8, _hoisted_31),
                _hoisted_32,
                _hoisted_33
              ], 512), [
                [_vModelSelect, _ctx.selectedItems.originType]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_Multiselect, {
            class: "custom-multiselect",
            modelValue: _ctx.selectedArea,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedArea) = $event)),
            mode: "tags",
            "close-on-select": false,
            requierd: false,
            label: "title",
            trackBy: "title",
            searchable: true,
            canDeselect: false,
            options: _ctx.areasTitle(),
            placeholder: _ctx.translate('Select City'),
            valueProp: "id",
            noResultsText: _ctx.translate('noResultsFound')
          }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("button", {
          type: "reset",
          class: "btn btn-sm btn-white fw-bolder btn-active-light-primary me-2",
          "data-kt-menu-dismiss": "true",
          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
        }, _toDisplayString(_ctx.translate('reset')), 1),
        _createElementVNode("button", {
          type: "submit",
          "data-kt-menu-dismiss": "true",
          class: "btn btn-sm fw-bolder btn-primary",
          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, _toDisplayString(_ctx.translate('apply')), 1)
      ])
    ])
  ]))
}